import { useState, useCallback } from 'react'; // 导入 useCallback
import { flushSync } from 'react-dom'; // <--- IMPORT

// APIError 似乎未使用，如果确实不用可以注释或删除
// import { APIError } from './error';

export const useErrorHandler = () => {
  const [errorState, setErrorState] = useState({
    open: false,
    message: '',
    code: '',
    details: null,
    severity: 'error', // 默认严重性
    duration: 5000    // 默认持续时间
  });

  // *** 1. 修改函数签名，添加 customMessage 参数，并用 useCallback 包裹 ***
  const handleError = useCallback((error, customMessage = null) => {
    // console.log('Handling error with custom message:', customMessage); // 方便调试
    // console.log('Full error object:', error); // 方便调试
    // ... 保留你需要的其他 console.log ...

    let messageToShow = 'An unexpected error occurred'; // 设置默认消息
    let severityToShow = 'error'; // 设置默认严重性
    let durationToShow = 5000; // 设置默认时长
    let codeToShow = '';       // 设置默认代码
    let detailsToShow = null;  // 设置默认详情

    // *** 2. 优先处理传入的 customMessage ***
    if (customMessage) {
      messageToShow = customMessage;
      // (推荐) 根据自定义消息内容调整严重性
      if (customMessage.includes("saved locally")) {
        severityToShow = 'warning'; // 例如：本地保存提示使用“警告”级别更合适
        // durationToShow = 4000; // 也可以调整显示时长
      }
      // 注意：当有自定义消息时，我们通常不再深入解析 error 对象来获取消息，
      // 但如果需要，仍然可以在这里添加逻辑提取 error.code 等信息

    } else if (error?.response?.status === 403) {
      // *** 3. 如果没有 customMessage，则继续执行原有逻辑 ***
      // 特殊处理 403 状态码
      messageToShow = 'This exam has already been completed';
      codeToShow = 'EXAM_ALREADY_COMPLETED';
      severityToShow = 'info';
      durationToShow = 3000;

    } else if (error?.response?.data?.error?.message) {
      // 尝试从特定结构获取消息
      messageToShow = error.response.data.error.message;
      // 使用默认 severity 'error' 和 duration

    } else if (error?.response?.data?.message) {
      // 尝试从另一种结构获取消息
      messageToShow = error.response.data.message;
      // 使用默认 severity 'error' 和 duration

    } else if (error?.message) {
      // 使用 error 对象自带的 message (例如 "Network Error")
      messageToShow = error.message;
      // (可选) 可以替换掉生硬的 "Network Error"
      if (error.message === 'Network Error') {
        messageToShow = 'Network connection issue. Please check your connection.';
      }
      // 使用默认 severity 'error' 和 duration
    }
    // 如果以上条件都不满足，则使用最开始设置的默认 message

    // 设置最终的错误状态
    setErrorState({
      open: true,
      message: messageToShow,
      code: codeToShow, // 使用获取到的 code 或默认空字符串
      details: detailsToShow, // 使用获取到的 details 或默认 null
      severity: severityToShow,
      duration: durationToShow
    });

  }, []); // 依赖项为空数组，因为它只依赖 hook 内部的 setErrorState

  // 将 handleAPIError 也用 useCallback 包裹
  const handleAPIError = useCallback((apiError) => {
    let message = apiError.message || 'An error occurred.'; // 提供默认消息
    let severity = 'error';
    let duration = 5000;
    let code = apiError.code || '';
    let details = apiError.details || null;

    switch (apiError.code) {
      case 'EXAM_ALREADY_COMPLETED':
        severity = 'info';
        duration = 3000;
        break;
      case 'NO_ANSWERS':
        severity = 'warning';
        duration = 4000;
        break;
      // 可以添加更多 case
      default:
        // 使用默认值
        break;
    }

     setErrorState({
        open: true,
        message: message,
        code: code,
        details: details,
        severity: severity,
        duration: duration
      });
  }, []); // 依赖项为空数组

  // 将 clearError 也用 useCallback 包裹
  const clearError = useCallback(() => {
    setErrorState(prev => ({ ...prev, open: false }));
  }, []); // 依赖项为空数组

  // 返回包含修改后 handleError 的对象
  return { errorState, handleError, handleAPIError, clearError };
};